// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const configApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    imageUpload: builder.mutation({
      query: (body) => ({
        url: `/api/v1/upload/`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const { useImageUploadMutation } = configApiSlice;
